// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"banner-module--titleContainer--3qXGM","title":"banner-module--title--3eiow","overlay":"banner-module--overlay--On6qU"};